import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import guideAvatar from "../Assets/he-landing/guide-avatar.png";
import "./ChatbotButton.css";

// Floating Hé guide avatar with a welcome bubble that appears shortly after
// arrival, hides after 10s, and can be dismissed or seen again on hover/focus.
export default function GuideDock({ onClick, label, hasPopup }) {
  const { t } = useTranslation();
  const location = useLocation();
  const [greetingVisible, setGreetingVisible] = useState(false);
  const hideTimer = useRef(0);

  const hideGreeting = useCallback(() => {
    clearTimeout(hideTimer.current);
    setGreetingVisible(false);
  }, []);

  const showGreeting = useCallback(() => {
    setGreetingVisible(true);
    clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setGreetingVisible(false), 10000);
  }, []);

  useEffect(() => {
    const timer = setTimeout(showGreeting, 850);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer.current);
    };
  }, [showGreeting]);

  // On the landing page's phone hero, sit above the date picker and button
  const onHome = location.pathname === "/main";

  return (
    <div className={`chatbot-guide-dock${onHome ? " on-home" : ""}`}>
      <div
        className={`chatbot-guide-greeting${greetingVisible ? " is-visible" : ""}`}
        role="status"
        aria-live="polite"
        aria-hidden={!greetingVisible}
      >
        <span>{t("chatbotGuest.greeting", "Héy i am here")}</span>
        <button
          type="button"
          className="chatbot-guide-greeting-close"
          aria-label={t("chatbotGuest.closeGreeting", "Close greeting")}
          onClick={hideGreeting}
        >
          ×
        </button>
      </div>
      <button
        type="button"
        className="chatbot-guide-button"
        aria-label={label}
        aria-haspopup={hasPopup ? "dialog" : undefined}
        onPointerEnter={showGreeting}
        onFocus={showGreeting}
        onClick={() => {
          hideGreeting();
          onClick();
        }}
      >
        <img src={guideAvatar} alt="" width="88" height="88" />
      </button>
    </div>
  );
}
